export default __webpack_public_path__ + "static/media/sensotrend_connect_upload_data2.fb26caf2.png";